import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbLinkProps,
  BreadcrumbProps,
} from "@chakra-ui/react";
import Link from "next/link";

export interface BreadcrumbsProps extends BreadcrumbProps {
  breadcrumbs: Array<BreadcrumbLinkProps & { isLastChild?: boolean }>;
}
export function Breadcrumbs({ breadcrumbs, ...props }: BreadcrumbsProps) {
  const { href, ...rest } = breadcrumbs?.[0];
  const defaultStyles = {
    ...{
      _focus: { outline: "none" },
    },
  };
  const isLastOfIndex = (index: number) => index + 1 === breadcrumbs.length;

  return (
    <Breadcrumb color="blue.500" {...props} noOfLines={1} fontSize="sm">
      <BreadcrumbItem>
        <BreadcrumbLink {...defaultStyles} {...rest}>
          Home
        </BreadcrumbLink>
      </BreadcrumbItem>
      {breadcrumbs.map((breadcrumb, index) => (
        <BreadcrumbItem
          key={index}
          isLastChild={isLastOfIndex(index)}
          isCurrentPage={isLastOfIndex(index)}
        >
          {breadcrumb?.href ? (
            <BreadcrumbLink {...defaultStyles} {...breadcrumb} />
          ) : (
            <BreadcrumbLink
              fontWeight="bold"
              {...breadcrumb}
              {...defaultStyles}
              {...{ _hover: { textDecoration: "none" } }}
            />
          )}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}
